import { render, staticRenderFns } from "./ReferalProgramSettings.vue?vue&type=template&id=34c47f8c"
import script from "./ReferalProgramSettings.vue?vue&type=script&lang=js"
export * from "./ReferalProgramSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports